import React from 'react';
import ReserveFieldTitle from '@/components/reserve/ReserveFieldTitle/ReserveFieldTitle';
import { cn } from '@gettactic/helpers';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export interface ReserveFormMeetingRoomTitleProps {
  className?: string;
}

export const ReserveFormMeetingRoomTitle: React.FC<
  ReserveFormMeetingRoomTitleProps
> = ({ className }) => {
  const { isMeetingRoom, form } = useReserveForm();
  if (!isMeetingRoom) return null;

  return (
    <div className={cn('', className)}>
      <ReserveFieldTitle form={form} withDescription />
    </div>
  );
};
